import React, { useEffect, useState } from 'react'
import '../../assets/css/salesforce.css'

const SAP = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const faqData = [
        {
            question: "What is SAP and how can it benefit my business?",
            answer: "SAP is a leading enterprise resource planning (ERP) software that integrates various business processes into a unified system. It helps streamline operations, improve decision-making, reduce costs, and enhance overall business efficiency through real-time data and analytics."
        },
        {
            question: "How long does SAP implementation typically take?",
            answer: "SAP implementation timelines vary based on project scope, complexity, and business requirements. A typical implementation can range from 6-18 months, including planning, configuration, testing, training, and go-live phases."
        },
        {
            question: "Do you provide SAP training for our team?",
            answer: "Yes, we offer comprehensive SAP training programs including end-user training, administrator training, and developer training. Our training is customized to your specific SAP modules and business processes."
        },
        {
            question: "Can SAP integrate with our existing systems?",
            answer: "Absolutely. SAP provides robust integration capabilities and we specialize in integrating SAP with various third-party systems, legacy applications, databases, and cloud services to create a seamless IT ecosystem."
        },
        {
            question: "What kind of support do you provide after implementation?",
            answer: "We offer comprehensive post-implementation support including 24/7 technical assistance, system monitoring, regular updates, performance optimization, and ongoing maintenance to ensure your SAP system runs optimally."
        },
        {
            question: "Is SAP cloud-based or on-premise?",
            answer: "SAP offers both cloud-based (SAP S/4HANA Cloud) and on-premise deployment options. We help you choose the right deployment model based on your business needs, budget, and IT infrastructure requirements."
        }
    ];

    return (
        <div>
            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="breadcrumb-title">
                                    SAP ERP Solutions
                                </h1>
                                <p className="breadcrumb-subtitle text-white">
                                    Comprehensive SAP implementation, customization, and support services to transform your business operations<br /> and drive digital innovation with the world's leading enterprise software platform.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section>

            <section className="ai-driven-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="ai-driven-content">
                                <h2 className="ai-driven-title" style={{ textAlign: 'left' }}>
                                    <span className="text-gradient">Our SAP</span> Services
                                </h2>
                                <p className="ai-driven-description">
                                    CLOUD MIND X delivers end-to-end SAP solutions, from strategic consulting and implementation to ongoing support and optimization. As certified SAP partners, we leverage deep expertise to help organizations harness the full potential of SAP ERP and achieve operational excellence across all business functions.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="ai-driven-image-wrapper">
                                <img
                                    src={require('../../assets/images/services/cloud-server.png')}
                                    alt="SAP ERP Solutions"
                                    className="ai-driven-image"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* SAP Services Section */}
            <section className="salesforce-services-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center mb-5">
                            <h2 className="salesforce-services-title">
                                Our <span className="text-gradient">SAP Services</span>
                            </h2>
                            <p className="salesforce-services-subtitle">
                                Complete SAP solutions designed to optimize your business processes and accelerate digital transformation
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        {/* Service Card 1 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <img
                                        src={require('../../assets/images/services/consultant.png')}
                                        alt="SAP Consulting"
                                        style={{ width: '48px', height: '48px', objectFit: 'contain' }}
                                    />
                                </div>
                                <h3 className="sf-service-title">SAP Consulting</h3>
                                <p className="sf-service-description">
                                    Strategic guidance to align SAP with your business objectives. Our certified consultants analyze your current processes, identify optimization opportunities, and develop a comprehensive roadmap for successful SAP implementation and digital transformation.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 2 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <img
                                        src={require('../../assets/images/services/chip.png')}
                                        alt="SAP Implementation"
                                        style={{ width: '48px', height: '48px', objectFit: 'contain' }}
                                    />
                                </div>
                                <h3 className="sf-service-title">SAP Implementation</h3>
                                <p className="sf-service-description">
                                    Seamless deployment of SAP tailored to your specific business requirements. From initial setup and configuration to data migration and user training, we ensure a smooth transition and rapid adoption of your new ERP system.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 3 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <img
                                        src={require('../../assets/images/services/ai-stack.png')}
                                        alt="SAP Customization"
                                        style={{ width: '48px', height: '48px', objectFit: 'contain' }}
                                    />
                                </div>
                                <h3 className="sf-service-title">SAP Customization</h3>
                                <p className="sf-service-description">
                                    Tailor SAP to perfectly fit your business processes. We customize workflows, user interfaces, and business logic to match your unique requirements, ensuring maximum efficiency and user adoption across your organization.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 4 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <img
                                        src={require('../../assets/images/services/blockchain.png')}
                                        alt="SAP Development"
                                        style={{ width: '48px', height: '48px', objectFit: 'contain' }}
                                    />
                                </div>
                                <h3 className="sf-service-title">SAP Development</h3>
                                <p className="sf-service-description">
                                    Build custom applications and extensions on the SAP platform. Our ABAP developers create powerful, scalable solutions to extend SAP functionality and integrate with third-party systems for enhanced business capabilities.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 5 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <img
                                        src={require('../../assets/images/services/cloud-server.png')}
                                        alt="SAP Integration"
                                        style={{ width: '48px', height: '48px', objectFit: 'contain' }}
                                    />
                                </div>
                                <h3 className="sf-service-title">SAP Integration</h3>
                                <p className="sf-service-description">
                                    Seamlessly integrate SAP with your existing systems and applications. We provide robust integration solutions using SAP PI/PO, SAP Cloud Platform Integration, and APIs to create a unified enterprise ecosystem.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 6 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <img
                                        src={require('../../assets/images/services/mvp.png')}
                                        alt="SAP Support"
                                        style={{ width: '48px', height: '48px', objectFit: 'contain' }}
                                    />
                                </div>
                                <h3 className="sf-service-title">SAP Support & Maintenance</h3>
                                <p className="sf-service-description">
                                    Comprehensive support services to keep your SAP system running optimally. We provide 24/7 technical assistance, regular updates, performance monitoring, security patches, and continuous improvements to ensure maximum ROI.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 7 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <img
                                        src={require('../../assets/images/services/ai-ml.png')}
                                        alt="SAP Migration"
                                        style={{ width: '48px', height: '48px', objectFit: 'contain' }}
                                    />
                                </div>
                                <h3 className="sf-service-title">SAP Migration & Upgrade</h3>
                                <p className="sf-service-description">
                                    Smooth migration from legacy systems to SAP S/4HANA or upgrade existing SAP systems. We handle data migration, system upgrades, and process transitions while minimizing downtime and ensuring data integrity.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 8 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <img
                                        src={require('../../assets/images/services/app.png')}
                                        alt="SAP Training"
                                        style={{ width: '48px', height: '48px', objectFit: 'contain' }}
                                    />
                                </div>
                                <h3 className="sf-service-title">SAP Training</h3>
                                <p className="sf-service-description">
                                    Empower your team with comprehensive SAP training programs. We offer end-user training, administrator training, and developer training customized to your specific SAP modules and business processes.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* SAP Products Section */}
            <section className="salesforce-clouds-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center mb-3">
                            <h2 className="salesforce-clouds-title">
                                SAP Products <span className="text-gradient">We Cover</span>
                            </h2>
                            <p className="salesforce-clouds-subtitle">
                                Deliver a personalized SAP experience that seamlessly integrates with your organization's goals and operational requirements.
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        {/* SAP S/4HANA */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#00D4FF" />
                                        <path d="M18 24L22 28L30 20" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">S/4HANA</h3>
                            </div>
                        </div>

                        {/* SAP ECC */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#FF6B9D" />
                                        <path d="M24 14C28.4183 14 32 17.5817 32 22C32 26.4183 28.4183 30 24 30C19.5817 30 16 26.4183 16 22C16 17.5817 19.5817 14 24 14Z" stroke="white" strokeWidth="2.5" />
                                        <path d="M24 30V34" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">ECC</h3>
                            </div>
                        </div>

                        {/* SAP BW */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#00A1E0" />
                                        <path d="M14 24L20 18L26 24L34 16" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M28 16H34V22" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">BW/4HANA</h3>
                            </div>
                        </div>

                        {/* SAP CRM */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#A78DFF" />
                                        <circle cx="24" cy="18" r="4" stroke="white" strokeWidth="2.5" />
                                        <circle cx="16" cy="28" r="3" stroke="white" strokeWidth="2.5" />
                                        <circle cx="32" cy="28" r="3" stroke="white" strokeWidth="2.5" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">CRM</h3>
                            </div>
                        </div>

                        {/* SAP SCM */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#8B5CF6" />
                                        <path d="M16 20H32M16 20V30H32V20M16 20L24 14L32 20" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M20 26V30" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                        <path d="M24 26V30" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                        <path d="M28 26V30" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">SCM</h3>
                            </div>
                        </div>

                        {/* SAP HCM */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#FFA726" />
                                        <path d="M24 14L19 19V32H29V19L24 14Z" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M19 22H29" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">HCM</h3>
                            </div>
                        </div>

                        {/* SAP FI/CO */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#00A8E1" />
                                        <circle cx="24" cy="24" r="8" stroke="white" strokeWidth="2.5" />
                                        <path d="M24 16V14M24 34V32M16 24H14M34 24H32" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">FI/CO</h3>
                            </div>
                        </div>

                        {/* SAP MM */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#10B981" />
                                        <path d="M16 18L20 14L24 18L28 14L32 18V30C32 31.1046 31.1046 32 30 32H18C16.8954 32 16 31.1046 16 30V18Z" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">MM</h3>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* FAQ Section */}
            <section className="faq-section" style={{ backgroundColor: '#f8f9fa', padding: '80px 0' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center mb-5">
                            <h2 className="salesforce-services-title">
                                Frequently Asked <span className="text-gradient">Questions</span>
                            </h2>
                            <p className="salesforce-services-subtitle">
                                Get answers to common questions about our SAP services and solutions
                            </p>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="accordion" id="sapFAQ">
                                {faqData.map((faq, index) => (
                                    <div className="accordion-item" key={index} style={{ marginBottom: '10px', border: '1px solid #e9ecef', borderRadius: '8px' }}>
                                        <h2 className="accordion-header" id={`heading${index}`}>
                                            <button
                                                className="accordion-button"
                                                type="button"
                                                onClick={() => toggleFAQ(index)}
                                                aria-expanded={activeIndex === index}
                                                style={{
                                                    backgroundColor: '#fff',
                                                    border: 'none',
                                                    borderRadius: '8px',
                                                    padding: '20px',
                                                    fontSize: '16px',
                                                    fontWeight: '600',
                                                    color: '#333',
                                                    textAlign: 'left',
                                                    width: '100%',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                {faq.question}
                                                <span style={{
                                                    float: 'right',
                                                    transform: activeIndex === index ? 'rotate(45deg)' : 'rotate(0deg)',
                                                    transition: 'transform 0.3s ease'
                                                }}>
                                                    +
                                                </span>
                                            </button>
                                        </h2>
                                        <div
                                            className={`accordion-collapse collapse ${activeIndex === index ? 'show' : ''}`}
                                            aria-labelledby={`heading${index}`}
                                            data-bs-parent="#sapFAQ"
                                        >
                                            <div className="accordion-body" style={{
                                                padding: '0 20px 20px 20px',
                                                color: '#666',
                                                lineHeight: '1.6'
                                            }}>
                                                {faq.answer}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="salesforce-contact-section">
                <div className="salesforce-contact-overlay"></div>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-8">
                            <div className="salesforce-contact-content">
                                <h2 className="salesforce-contact-title">Get in touch</h2>
                                <p className="salesforce-contact-description">
                                    Ready to transform your business operations with SAP ERP? Contact our certified consultants to discover how SAP can streamline your processes and drive growth.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 text-center text-lg-end">
                            <button className="salesforce-contact-btn">
                                Contact us
                            </button>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default SAP;
